import React from 'react'

import {Card} from '@vio/atlas/Card'
import {Divider} from '@vio/atlas/Divider'
import {Box} from '@vio/atlas/helpers/Box'
import {Icon} from '@vio/atlas/Icon'
import {Tag} from '@vio/atlas/Tag'
import {Text} from '@vio/atlas/Text'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'
import UnifiedDateTime from '@vio/shared/src/utils/UnifiedDateTime'

interface Props {
  expiresAt: string
  /** Full-width strip at the top of the offer box, instead of a bordered card */
  isStrip?: boolean
}

export const FrozenDealBanner: React.FC<Props> = ({
  expiresAt,
  isStrip = false
}) => {
  const content = (
    <Box padding="s400" display="flex" flexDirection="column" gap="s200">
      <Box display="flex" flexWrap="wrap" alignItems="center" gap="s250">
        <Text variant="titleS">
          <FormattedMessageWrapper
            id="dealFreeze.postFreezeBannerTitle"
            defaultMessage="Your deal is frozen"
          />
        </Text>
        <Tag
          variant="brand"
          size="sm"
          iconStart={<Icon name="ShieldTick" size="sm" />}
        >
          <FormattedMessageWrapper
            id="dealFreeze.bestPriceSecured"
            defaultMessage="Best price secured"
          />
        </Tag>
      </Box>
      <Box display="flex" flexDirection="column" gap="s200">
        <Text variant="bodyXS" tag="div">
          <FormattedMessageWrapper
            id="dealFreeze.frozenUntilBannerSubheading"
            defaultMessage="Guaranteed until {date}"
            values={{
              date: (
                <UnifiedDateTime value={expiresAt} format="datetime-short" />
              )
            }}
          />
        </Text>
        <Text variant="bodyXS" tag="div" colorPath="content.neutral.secondary">
          <FormattedMessageWrapper
            id="dealFreeze.frozenUntilBannerSubtitleV2"
            defaultMessage="We're watching the price. If it drops, we'll refreeze your deal at the lower rate."
          />
        </Text>
      </Box>
    </Box>
  )

  if (isStrip) {
    return (
      <>
        {content}
        <Divider />
      </>
    )
  }

  return (
    <Card borderRadius="lg" borderColorPath="border.neutral.secondary">
      {content}
    </Card>
  )
}
